/* global euAdminConfig */

function _t(translation) {
    if (!euAdminConfig || !euAdminConfig.translations) {
        return translation;
    }

    return euAdminConfig.translations[translation] || translation;
}

module.exports = _t;
